import React from 'react';

import NewsletterList from '../../components/Communication/NewsletterList/NewsletterList.module';

function NewsletterListView() {
  return (
    <NewsletterList />
  );
}

export default NewsletterListView;
